import { ReactNode } from "react";

export interface ICommonTableColumn<T> {
  key: string;
  /** Plain text in almost every table; a node when the header itself is a control. */
  header: ReactNode;
  className?: string;
  render?: (row: T) => ReactNode;
  sortable?: boolean;
}

export enum TableSelectionMode {
  NONE = "NONE",
  SINGLE = "SINGLE",
  MULTIPLE = "MULTIPLE",
}

export interface ICommonTableProps<T> {
  columns: ICommonTableColumn<T>[];
  data: T[];
  page?: number;
  pageSize?: number;
  total?: number;
  onPageChange?: (page: number) => void;
  onPageSizeChange?: (pageSize: number) => void;
  isLoading?: boolean;
  hasNextPage?: boolean;
  hasPreviousPage?: boolean;
  onRowClick?: (row: T) => void;
  rowMenu?: (row: T) => ReactNode;
  selectionMode?: TableSelectionMode;
  selectedRows?: T[];
  onSelectionChange?: (selected: T[]) => void;
  errorMessage?: string;
  sortKey?: string;
  sortDirection?: "asc" | "desc";
  onSortChange?: (key: string, direction: "asc" | "desc") => void;
  hideFooter?: boolean;
  loadingRowSkeleton?: ReactNode;
  getRowId?: (row: T) => string | number;
  pageSizeOptions?: number[];
  emptyMessage?: string;
  loadingMessage?: string;
  showLabel?: string;
  rowsPerPageLabel?: string;
}
